// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SgSgkcG3D9SLR3 {
  max-width: 30%;
  margin: 30px auto;
}
.hfFO_9xEGwM7MP > span {
  display: flex;
  align-items: center;
  margin-right: -5px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errContainer": `SgSgkcG3D9SLR3`,
	"learnHow": `hfFO_9xEGwM7MP`
};
export default ___CSS_LOADER_EXPORT___;
